import Barmenu from "./Composants/utilitaires/Barmenu";
import Piedpage from "./Composants/utilitaires/Piedpage";
import Corpmonecole from "./Composants/utilitaires/corpmonecole";
//import './Composants/utilitaires/style.css';
function Monecole(){
    return(
        <>
            <Corpmonecole/>
        </>
    )
}
export default Monecole;